import { clsx } from 'clsx';
import { useParams } from 'next/navigation';
import { CSSProperties } from 'react';
import { NavigationItemStoryblok } from 'storyblok-types';
import { StoryBlokLink } from 'atoms/StoryBlokLink';
import { CTA } from 'atoms/Typography/Typography';
import {
  gtmPushSecondNavigationLevel,
  gtmPushThirdNavigationLevel,
} from 'modules/gtm/modules/sections/navigation/navigation';
import { usePathname } from 'modules/next/hooks';
import { Regex } from 'src/client/modules/validation';
import styles from './ColumnItem.module.css';

export const ColumnItem = ({
  navItem,
  itemParentTitle,
}: {
  navItem: NavigationItemStoryblok;
  itemParentTitle?: string;
}) => {
  const pathname = usePathname();
  const { locale } = useParams();
  const style = {} as CSSProperties;

  if (navItem.textColor?.color) {
    style.color = navItem.textColor?.color;
  }

  const handleColumnButtonClick = (columnItemTitle: string) => {
    if (itemParentTitle) {
      gtmPushSecondNavigationLevel(itemParentTitle, columnItemTitle);
    }
  };

  const handleColumnLinkClick = (
    columnItemTitle: string,
    linkTitle: string,
  ) => {
    if (itemParentTitle) {
      gtmPushThirdNavigationLevel(itemParentTitle, columnItemTitle, linkTitle);
    }
  };

  return (
    <div className={styles.root}>
      {navItem.url && (
        <StoryBlokLink
          className={styles.itemLink}
          style={style}
          link={navItem.url}
          onClick={() => handleColumnButtonClick(navItem.title || 'Unknown')}
        >
          <CTA type="lg">{navItem.title}</CTA>
        </StoryBlokLink>
      )}
      {!!navItem?.children?.length && (
        <ul className={styles.children}>
          {navItem.children.map((item: NavigationItemStoryblok) => {
            const href = (
              item.url?.story?.full_slug || item.url?.cached_url
            )?.replace(`${locale}/`, '');

            return item.url ? (
              <li key={item._uid}>
                <StoryBlokLink
                  link={item.url}
                  className={clsx(
                    styles.child,
                    href === pathname.replace(Regex.slashes, '') &&
                      styles.current,
                  )}
                  onClick={() => {
                    handleColumnLinkClick(
                      navItem.title,
                      item.title || 'Unknown',
                    );
                  }}
                >
                  <CTA type="md">{item.title}</CTA>
                </StoryBlokLink>
              </li>
            ) : null;
          })}
        </ul>
      )}
    </div>
  );
};
